class AdpStatusIconController {
  constructor() {
    this.name = 'adpStatusIcon';
  }
}

export default AdpStatusIconController;



// WEBPACK FOOTER //
// ./src/app/components/adpStatusIcon/adpStatusIcon.controller.js